import { noop } from 'lodash';
import { createContext, useContext } from 'react';

import { Sector } from '../model/sector';

export interface RiskGroupOption {
  id: string;
  appLabel: string;
  isUsersActiveSector: boolean;
}

export interface SectorState {
  sectorsQueryData: Sector[];
  selectedSectors: RiskGroupOption[];
  setSelectedSectors: (sectors: RiskGroupOption[]) => void;
  isFetching: boolean;
  onRiskGroupChange: (selectedSectors: RiskGroupOption[]) => void;
}

export const SectorContext = createContext<SectorState>({
  sectorsQueryData: [],
  selectedSectors: [],
  setSelectedSectors: noop,
  isFetching: false,
  onRiskGroupChange: noop,
});

export const useSectors = (): SectorState => {
  return useContext(SectorContext);
};
